import React from "react";
import Icons from "../../components/Icons";

function getIcon(variant) {
  switch (variant) {
    case "success":
      return <Icons icon={"success"} />;
    case "warning":
      return <Icons icon={"warning"} />;
    case "error":
      return <Icons icon={"error"} />;
    case "information":
      return <Icons icon={"information"} />;
  }
}

export default function CustomizedSnackbars(props) {
  const items = props.settings || [];

  return (
    <div className="notification-wrapper">
      {items.map((item) => (
        <Notitfication data={item} key={item.id} />
      ))}
    </div>
  );
}

class Notitfication extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  close = (cb, id) => {
    const element = document.getElementById(id);
    if (element) {
      element.classList.remove("slide-in");
      element.classList.add("slide-off");
    }
    setTimeout(() => {
      cb();
    }, 900);
  };

  render() {
    const { variant, message, open, closeBar, id } = this.props.data || [
      "success",
      "message",
      false,
      () => {},
      null,
    ];

    setTimeout(() => {
      closeBar && this.close(closeBar, id);
    }, 3000);
    return (
      <div className="notification-container">
        <div
          id={id}
          key={id}
          className={`notification-slide slide-in notificaion-${variant}`}
        >
          <div>{getIcon(variant)}</div>
          <p>{message}</p>
          <div>
            <Icons
              onClick={() => closeBar && this.close(closeBar, id)}
              icon={"time"}
            />
          </div>
        </div>
      </div>
    );
  }
}
